export default __webpack_public_path__ + "static/media/sos-seen.6b3448f5.svg";